import axios from 'axios'
import errorHandler from './error-handler'

export default {
  async signup (data) {
    return axios.post('/api/accounts', data)
      .then(r => r.data).catch(errorHandler)
  },
  async respond (data) {
    return axios.post('/api/accounts/challenge', data)
      .then(r => r.data).catch(errorHandler)
  },
  async login (data) {
    return axios.post('/api/accounts/login', data)
      .then(r => r.data).catch(errorHandler)
  },
  async verify (data) {
    return axios.post('/api/accounts/verify', data)
      .then(r => r.data).catch(errorHandler)
  },
  async magic (data) {
    return axios.post('/api/accounts/magic', data)
      .then(r => r.data).catch(errorHandler)
  },
  async logout (data) {
    return axios.delete('/api/accounts/logout')
      .then(r => r.data).catch(errorHandler)
  },
  async loginLinkedIn (authCode) {
    return axios.post('/api/accounts/login/linkedin', {authCode})
      .then(r => r.data).catch(errorHandler)
  },
  async loginGithub (authCode) {
    return axios.post('/api/accounts/login/github', {authCode})
      .then(r => r.data).catch(errorHandler)
  },
  async loginGoogle (authCode) {
    return axios.post('/api/accounts/login/google', {authCode})
      .then(r => r.data).catch(errorHandler)
  }
}



// WEBPACK FOOTER //
// ./src/api/accounts.js